// extracted by mini-css-extract-plugin
export default {"root":"InstanceConfig_root__GVM6h","header":"InstanceConfig_header__h2R7S","body":"InstanceConfig_body__8LhMf"};